import React, { useMemo } from 'react';
import Icon from '@ant-design/icons';
import { InfoCircleFilled, QuestionCircleFilled } from '@ant-design/icons'
import { Container, Popover } from './styles'

// type ExtractProperty<O extends Record<string, any>, K extends keyof O> = O[K];

interface IHelpWordProps {
    word: string;
    word_desc?: string;
    className: string;
    place: any;
    color: any;
}

export const HelpWord: React.FC<IHelpWordProps> = (props) => {
    const { word, word_desc, className, place, color = '#9D9EA2' } = props;

    return (<Container className={className}>

      <a data-tip data-for='stibee-tooltip'><Icon component={QuestionCircleFilled} style={{fill:"#9D9EA2"}} size={16} /></a>
        <Popover id='stibee-tooltip' effect='solid' backgroundColor="#fff" textColor='#404040' place={place}
        className="custom-tooltip" delayHide={500} style={{width: '140px', lineHeight: '22px'}} >
          <div dangerouslySetInnerHTML={{__html:word}}></div>
        </Popover>
    </Container>
    );
};

export default HelpWord